
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ChallengesSection from './components/ChallengesSection';
import SolutionsSection from './components/SolutionsSection';
import ProcessSection from './components/ProcessSection';
import TimelineSection from './components/TimelineSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import PropertyTypesSection from './components/PropertyTypesSection';
import ComparisonSection from './components/ComparisonSection';
import TenantBenefitsSection from './components/TenantBenefitsSection';
import LegalProtectionSection from './components/LegalProtectionSection';
import TitleCompanySection from './components/TitleCompanySection';
import MarketInsightsSection from './components/MarketInsightsSection';
import TrackRecordSection from './components/TrackRecordSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function RentalPropertyPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Sell Rental Property El Paso | We Buy Rental Houses with Tenants"
        description="Sell your rental property fast for cash in El Paso. We buy rental houses with or without tenants, handle problem tenants, and close quickly. No repairs needed."
        keywords="sell rental property El Paso, sell house with tenants, rental property buyers, landlord exit strategy, sell investment property fast"
        canonical="/rental-property"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Rental Property Buying Service",
          "provider": {
            "@type": "RealEstateAgent",
            "name": "TREX RE LLC"
          },
          "areaServed": "El Paso, TX"
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <IntroSection />
      <ChallengesSection />
      <SolutionsSection />
      <ProcessSection />
      <TimelineSection />
      <WhyChooseUsSection />
      <PropertyTypesSection />
      <ComparisonSection />
      <TenantBenefitsSection />
      <LegalProtectionSection />
      <TitleCompanySection />
      <MarketInsightsSection />
      <TrackRecordSection />
      <CaseStudiesSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
